/**
 * KiekkoKingi section controller: contact-form
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
      const rootId = kkScript.dataset.rootId;
      const sectionId = kkScript.dataset.sectionId;
      const destroy = (root) => {
        if (!root || !root.__kiekkokingiContactFormCleanup) return;
        root.__kiekkokingiContactFormCleanup.forEach((cleanup) => cleanup());
        root.__kiekkokingiContactFormCleanup = null;
        root.removeAttribute('data-contact-form-initialized');
      };
  
      const init = (root) => {
        if (!root || root.hasAttribute('data-contact-form-initialized')) return;
        root.setAttribute('data-contact-form-initialized', 'true');
        const cleanup = [];
        const topicSelect = root.querySelector('[data-kiekkokingi-contact-topic-field]');
        const orderField = root.querySelector('[data-order-number-field]');
  
        const syncOrderField = () => {
          if (!orderField) return;
          const mode = root.dataset.orderNumberMode || 'topic_based';
          const selectedOption = topicSelect && topicSelect.selectedIndex >= 0 ? topicSelect.options[topicSelect.selectedIndex] : null;
          const showForTopic = selectedOption && selectedOption.dataset.showOrderNumber === 'true';
          const shouldShow = mode === 'always' || (mode === 'topic_based' && showForTopic);
          orderField.hidden = !shouldShow;
          root.classList.toggle('kk-contact-form--order-hidden', !shouldShow);
        };
  
        if (topicSelect) {
          const onTopicChange = () => syncOrderField();
          topicSelect.addEventListener('change', onTopicChange);
          cleanup.push(() => topicSelect.removeEventListener('change', onTopicChange));
        }
  
        const onTopicSelected = (event) => {
          if (!topicSelect || !event.detail || !event.detail.value || !event.detail.sectionId) return;
          const source = document.getElementById(`KiekkoKingiContactTopics-${event.detail.sectionId}`);
          if (!source) return;
          const sourceAnchor = source.dataset.formAnchor || '';
          const anchorTarget = sourceAnchor ? document.getElementById(sourceAnchor) : null;
          if (!sourceAnchor || sourceAnchor !== root.dataset.formAnchor || !anchorTarget || !root.contains(anchorTarget)) return;
  
          const match = Array.from(topicSelect.options).find((option) => option.value === event.detail.value && !option.disabled);
          if (!match) return;
          topicSelect.value = event.detail.value;
          topicSelect.dispatchEvent(new Event('input', { bubbles: true }));
          topicSelect.dispatchEvent(new Event('change', { bubbles: true }));
          syncOrderField();
        };
  
        document.addEventListener('kiekkokingi:contact-topic-selected', onTopicSelected);
        cleanup.push(() => document.removeEventListener('kiekkokingi:contact-topic-selected', onTopicSelected));
        syncOrderField();
  
        const success = root.querySelector('[data-contact-form-success]');
        if (success && !(window.Shopify && window.Shopify.designMode)) {
          window.requestAnimationFrame(() => success.focus({ preventScroll: true }));
        }
  
        root.__kiekkokingiContactFormCleanup = cleanup;
      };
  
      const onSectionLoad = (event) => {
        if (!event.detail || event.detail.sectionId !== sectionId) return;
        init(document.getElementById(rootId));
      };
  
      const onSectionUnload = (event) => {
        if (!event.detail || event.detail.sectionId !== sectionId) return;
        const root = event.target.querySelector('[data-kiekkokingi-contact-form]') || document.getElementById(rootId);
        destroy(root);
        document.removeEventListener('shopify:section:load', onSectionLoad);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
      };
  
      init(document.getElementById(rootId));
      document.addEventListener('shopify:section:load', onSectionLoad);
      document.addEventListener('shopify:section:unload', onSectionUnload);
    })();
})();